exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form>.btn[data-v-276eb2ce]{background-color:var(--color-white,#fff);color:var(--color-curious-blue,#2286c3);border:1px solid var(--color-curious-blue,#2286c3)}form>.btn[data-v-276eb2ce]:hover,form>div>div>label[data-v-276eb2ce],form>div>div>span[data-v-276eb2ce]{background-color:var(--color-curious-blue,#2286c3);color:var(--color-white,#fff)}form>div>div>label[data-v-276eb2ce],form>div>div>span[data-v-276eb2ce]{border-color:var(--color-curious-blue,#2286c3)}form>div>div>span.customized-span[data-v-276eb2ce]{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}form>div>input[data-v-276eb2ce],form>div>select[data-v-276eb2ce]{border-color:var(--color-curious-blue,#2286c3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-276eb2ce","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/remboursements/components/Read.vue
// module id = 665
// module chunks = 0